



















export default {
  name: 'WarningModal',
  props: {
    'header-text': {
      // type: { roles: [ { id: 1, name: '' } ] }
    },
    'body-text': {},
    'success-button-text': {},
    'cancel-button-text': {}
  },
  data () {
    return {
    }
  },
  components: {
  },
  created: function () {
    // console.log("created modal");
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/WarningModal.vue